/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamAdmVault extends GContentBase<SeznamAdmVaultObj> {
        private seznamObj: SeznamAdmVaultObj & GContent;
        private jePovolenaVerze: boolean;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamAdmVaultObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamAdmVault",
                contentCaption: "jres:33000566", //RC 33000566 : Trezory
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{nazev}"
                },
                gridSettings: {
                    columnOrder: "poradi,typ_vau_txt,nazev,poznamka,ixs_vau,nazev_azure,ixs_oap_txt,path,dat_zmena,zmenu_prov_txt"
                }
            })
            this.seznamObj.jePovolenaVerzeBase = this.jePovolenaVerze;
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
            this.cnt.showFlash({
                content: this.jePovolenaVerzeBase == true ? "jres:33000641" : "jres:33000642", //RC 33000642 : Při jakékoliv změně v oblasti trezorů se nastavení projeví až při opětovném přihlášení.
                state: "info"
            })
        }
    }

    export class SeznamAdmVaultObj extends GAdmSeznamBase {
        jePovolenaVerzeBase: boolean;
        private srv: GContent;

        private getSrv(): GContent {
            if (!this.srv)
                this.srv = this.cnt.createServiceContent("Gordic.Adm.WebControls.SeznamAdmVault");
            return this.srv;
        }

        create() {
            
        }

        openDetail(data: any, isNew: boolean) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmVault", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid)
            }], {
                ID: "DetailAdmVault",
                newRecord: isNew,
                ixs_vau: isNew == true ? null : data.ixs_vau
            })
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return {
                actPosunUp: {
                    caption: "jres:33000568", //RC 33000568 : Posunout nahoru
                    icon: "gi-arrow gi-rot270",
                    run: (ev, ctx) => {
                        this.poradiUp();
                    }
                },
                actPosunDown: {
                    caption: "jres:33000570", //RC 33000570 : Posunout dolů
                    icon: "gi-arrow gi-rot90",
                    run: (ev, ctx) => {
                        this.poradiDown();
                    }
                },
                actFindSecretLocation: {
                    caption: "jres:33000597", //RC 33000593 : Hledat tajemství v trezorech
                    icon: "fa-search",
                    run: (ev, ctx) => {
                        this.searchLocationForm();
                    }
                },
                actFindSecretLocationOk: {
                    caption: "jres:33000243",
                    run: (ev, ctx) => {
                        this.searchLocationOk(ev);
                    }
                },
                actCloseDialog: {
                    caption: "jres:32131042",
                    run: (ev, ctx) => {
                        $.content(ev.target).close();
                    }
                },
                actReload: {
                    caption: "jres:33000640", //RC 33000640 : Obnovit  trezory
                    tooltip: "jres:33000643", //RC 33000643 : Slouží ke znovunačtení aktuální konfigurace trezorů. Používejte pokud trezory jakýmkoliv způsobem upravujete, přidáváte nebo měníte jejich pořadí.
                    icon: "gi-refresh",
                    run: (ev, ctx) => {
                        this.reloadVaults();
                    }
                }
            }
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar(["actOpenDetail*", "actNewDetail*", "actPosunUp*", "actPosunDown*", "actAddToComparison*",
                {
                    action: this.cnt.actions.actFindSecretLocation,
                    visible: this.jePovolenaVerzeBase == true,
                    favorite: true
                },
                {
                    action: this.cnt.actions.actReload,
                    visible: this.jePovolenaVerzeBase == true,
                    favorite: true
                }
            ]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar(["actOpenDetail*", "actPosunUp*", "actPosunDown*"])
        }

        createFilterForm() {

        }

        userhardDefaultFilter(hardFilter: any): any {
            return hardFilter;
        }

        collectData(data: any) {

        }

        applydata(filterData: any, poradi_new?: number) {
            this.cnt.isl.AdmVault.list({ filters: filterData }).getView().done((data) => {
                this.view = data;
                this.grid.ggrid('setData', this.view);
                if (poradi_new != null && poradi_new != undefined) {
                    var view = this.grid.ggrid("getView").getDataRows(false);
                    var finded = view.findIndex((obj) => obj.poradi == poradi_new);
                    if (finded != -1)
                        this.grid.ggrid("activeCellAddress", finded)
                }
            });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {
            this.cnt.actions.actPosunUp?.update({ enabled: false })
            this.cnt.actions.actPosunDown?.update({ enabled: false })
            if (objArr.count == 1) {
                var activeRow = this.grid.ggrid("activeRow");
                if (activeRow) {
                    if (activeRow.poradi != 1) {
                        this.cnt.actions.actPosunUp?.update({ enabled: true })
                    }
                    if (activeRow.poradi != activeRow.max_poradi) {
                        this.cnt.actions.actPosunDown?.update({ enabled: true })
                    }
                }
            }
        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: "{0}".format(data.ixs_vau),
                nazev: data["nazev"]
            }
        }

        private poradiUp() {
            var activeRow = this.grid.ggrid("activeRow");
            if (activeRow) {
                if (activeRow.poradi != 1)
                    this.cnt.isl.AdmVault.changePoradi({ poradiOld: activeRow.poradi, poradiNew: activeRow.poradi - 1 }).getData().done(() => {
                        this.cnt.notification("showToast", { icon: "fa-check-circle", title: this.options.contentCaption, content: "jres:33000569", state: "success" }) //RC 33000569 : Změna pořadí proběhla úspěšně.
                        this.applydata(this.filterData, activeRow.poradi - 1);
                    })
            }
        }

        private poradiDown() {
            var activeRow = this.grid.ggrid("activeRow");
            if (activeRow) {
                if (activeRow.poradi != activeRow.max_poradi)
                    this.cnt.isl.AdmVault.changePoradi({ poradiOld: activeRow.poradi, poradiNew: activeRow.poradi + 1 }).getData().done(() => {
                        this.cnt.notification("showToast", { icon: "fa-check-circle", title: this.options.contentCaption, content: "jres:33000569", state: "success" }) //RC 33000569 : Změna pořadí proběhla úspěšně.
                        this.applydata(this.filterData, activeRow.poradi + 1);
                    })
            }
        }

        private reloadVaults() {
            this.getSrv().call("RealoadVaults").done(() => {
                this.cnt.actions.actReload?.setPending(100);
            }).fail(() => {
                this.cnt.actions.actReload?.setPending(900);
            })
        }

        private searchLocationForm() {
            var form = new Gordic.Forms.Form({ name: "formSearchPath", customClass: "formSearchPath" })
                .addRow("jres:33000598").addField("gstringbox", { //RC 33000594 : Hledaný tajemství
                    name: "path",
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required"
                })

            this.cnt.dialogs.simpleForm("jres:33000597", form, null, {
                height: 200,
                commandBar: [
                    {
                        action: this.cnt.actions.actFindSecretLocationOk,
                        primary: true,
                    },
                    {
                        action: this.cnt.actions.actCloseDialog
                    }
                ]
            })
        }

        private searchLocationOk(ev) {
            var cnt = $.content(ev.target);
            var form = cnt.findForms("formSearchPath");
            if (form.gform("isValid")) {
                var path = form.findFields("path").gfield("getValue");
                this.cnt.isl.AdmVault.getSecretLocation({ secretLocation: path }).get().done((result) => {
                    cnt.close();
                    if (result.exist == true)
                        this.cnt.dialogs.alert("jres:33000028", "jres:33000599".format(result.path?.toString(), result.vaultName?.toString())) //RC 33000595 : Zadaný klíč <b>{0} byl</b> nalezen v trezoru <b>{1}</b>.
                    else
                        this.cnt.dialogs.error("jres:33000028", "jres:33000600".format(result.path?.toString())) //RC 33000596 : Zadaný klíč <b>{0} nebyl</b> nalezen v trezoru.
                })
            }
        }
    }
}